export default {"src":"/_next/static/media/send.a9fc93fa.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};